import { Box, SvgIcon, Typography } from '@mui/material';
import TimeTrackingBot from 'assets/time-tracking-bot.svg';
import React from 'react';
import { I18n } from 'utils/i18n';

const TimeTrackingBotHelp = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
        }}
      >
        <SvgIcon sx={{ fontSize: 96 }}>
          <TimeTrackingBot />
        </SvgIcon>
        <Typography
          variant="h5"
          component="h1"
          sx={{ margin: '20px 0 20px 0', whiteSpace: 'pre-line' }}
        >
          {I18n.t('TimeTrackingDrawer.title')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
        }}
      >
        <Box
          sx={theme => ({
            background: theme.palette.secondary.ultraUltraLight,
            border: `1px solid ${theme.palette.secondary.extraLight}`,
            borderRadius: '6px',
            padding: theme.spacing(4),
            '& ul': {
              padding: '0 0 0 40px',
              listStylePosition: 'outside',
              marginBottom: 0,
              color: theme.palette.secondary.light,
            },
          })}
        >
          <ul>
            {[1, 2, 3].map(char => (
              <li key={`char.${char}`}>
                <Typography
                  sx={{
                    display: 'inline',
                    color: theme => theme.palette.black,
                    verticalAlign: 'middle',
                  }}
                >
                  {I18n.t(`TimeTrackingDrawer.infoBox.items.${char}`)}
                </Typography>
              </li>
            ))}
          </ul>
        </Box>
      </Box>
    </Box>
  );
};

export default TimeTrackingBotHelp;
